import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-[19rem] py-2" }
const _hoisted_2 = { class: "font-semibold" }

import { computed } from 'vue'
// @ts-expect-error module '@ui-kit/scripts/utils/date' is js and lacks type definitions
import dateUtils from '@ui-kit/scripts/utils/date'
import i18n from '@/scripts/app-configs/i18n-config'
import type { Reminder } from '@/components/drawers/MemberDrawer/types/member-drawer.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDrawerContentPatientReminders',
  props: {
    items: {}
  },
  setup(__props: any) {

const props = __props

const buttonLabel = computed(() => {
  const total = props.items
    .map((item) => item.days_of_week || [])
    .reduce((accumulator, currentArray) => accumulator + currentArray.length, 0)

  if (!total) return i18n.t('SIDEBAR.REMINDERS_NONE')

  return total > 1 ? i18n.t('SIDEBAR.REMINDERS_VIEW_TOTAL', { total }) : i18n.t('SIDEBAR.REMINDERS_VIEW_1')
})

const formatTime = (hour: number, minute: number): string => {
  return dateUtils.formatTime(hour, minute)
}

const abbreviatedDays = (days: string[]): string => {
  return days.map((day) => abbreviateDayOfWeek(day)).join(', ')
}

const abbreviateDayOfWeek = (dayOfWeek: string, lang = i18n.locale): string => {
  const date = dateUtils.getNextDate(dayOfWeek)
  const options: Intl.DateTimeFormatOptions = { weekday: 'short' }
  let weekday = new Intl.DateTimeFormat(lang as string, options).format(date)

  weekday = weekday.replace('.', '')

  return weekday.charAt(0).toUpperCase() + weekday.slice(1)
}


return (_ctx: any,_cache: any) => {
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!
  const _component_sword_popover_wuk = _resolveComponent("sword-popover-wuk")!

  return (_openBlock(), _createBlock(_component_sword_popover_wuk, {
    class: "relative inline-block",
    distance: 10,
    placement: "bottom-end"
  }, {
    content: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "flex justify-between px-4 py-3 text-xs"
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(formatTime(item.hour, item.min)), 1),
            _createElementVNode("span", null, _toDisplayString(abbreviatedDays(item.days_of_week)), 1)
          ]))
        }), 128))
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_sword_button_wuk, {
        theme: "secondary",
        icon: "schedule",
        size: "small",
        side: "left",
        text: buttonLabel.value,
        disabled: !__props.items.length,
        class: "!mt-2"
      }, null, 8, ["text", "disabled"])
    ], undefined, true),
    _: 1
  }))
}
}

})